import React from 'react';
import { funIconStyle } from './styles';

export const Fun: React.FC<{ size?: string }> = ({ size }) => {
  return (
    <div style={funIconStyle(size)}>
      <svg
        width="84px"
        height="64px"
        viewBox="0 0 84 64"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="goal-Fun-Fund4"
            transform="translate(-15.000000, -23.000000)"
            stroke="#FFFFFF"
            strokeWidth="2"
          >
            <path
              d="M40.9589203,61.056121 C37.2635245,57.120524 35,51.8245992 35,46 C35,33.8497355 44.8497355,24 57,24 C69.1502645,24 79,33.8497355 79,46 C79,52.2993926 76.3524117,57.9804078 72.1092941,61.9909866 L65.7422939,69.8495486 C65.0322303,70.7259548 64.7435134,71.0026528 64.3783408,71.2682432 C64.0131683,71.5338335 63.6295045,71.7167727 63.1932623,71.8333143 C62.7570201,71.9498559 62.3602773,72 61.2323242,72 L52.7407368,72 C51.621518,72 51.228376,71.951103 50.7957481,71.8369923 C50.3631202,71.7228815 49.9823712,71.543557 49.6188567,71.282702 C49.2553421,71.021847 48.9672524,70.7498988 48.2544201,69.8870427 L40.9589203,61.056121 Z"
              id="Combined-Shape"
            ></path>
            <path
              d="M58,72 C60.1935028,68.0709267 67.4980595,58.2944213 67.9630629,47.0810547 C68.4280662,35.8676881 64.4687404,27.0581055 58,24 M56,72 C53.8145043,68.0709267 46.4998096,57.155192 46.0365037,45.9418254 C45.5731978,34.7284588 49.5548729,27.0581055 56,24"
              id="Combined-Shape-Copy"
            ></path>
            <path
              d="M54.8251553,77 C53.6542057,77 53.0705061,77.1205456 52.5179075,77.4160786 C52.0403241,77.671493 51.671493,78.0403241 51.4160786,78.5179075 C51.1205456,79.0705061 51,79.6542057 51,80.8251553 L51,82.1748447 C51,83.3457943 51.1205456,83.9294939 51.4160786,84.4820925 C51.671493,84.9596759 52.0403241,85.328507 52.5179075,85.5839214 C53.0705061,85.8794544 53.6542057,86 54.8251553,86 L59.1748447,86 C60.3457943,86 60.9294939,85.8794544 61.4820925,85.5839214 C61.9596759,85.328507 62.328507,84.9596759 62.5839214,84.4820925 C62.8794544,83.9294939 63,83.3457943 63,82.1748447 L63,80.8251553 C63,79.6542057 62.8794544,79.0705061 62.5839214,78.5179075 C62.328507,78.0403241 61.9596759,77.671493 61.4820925,77.4160786 C60.9294939,77.1205456 60.3457943,77 59.1748447,77 L54.8251553,77 Z"
              id="Rectangle"
            ></path>
            <path
              d="M32.2666016,45.8753488 L82.1298828,45.8753488"
              id="Path-7"
            ></path>
            <path
              d="M22.6689453,86 C24.6028646,86 28.1321615,86 32,86 M30.6914063,81.5 C29.8564453,78.6993448 26.1850694,77 23.5,77 C21.1920411,77 19.0989227,77.9739498 17.5672505,79.5548551 M28,86 L38,86 C38,83.2385763 34.152832,80 30.6914063,81.5"
              id="Combined-Shape"
            ></path>
            <path
              d="M85,75.5 L78,75.5 C78,73.5670034 80.0147186,72 82.5,72 C83.6691161,72 84.7341008,72.3467641 85.5342092,72.9152684 C86.5337321,70.6114404 88.82868,69 91.5,69 C95.0898509,69 98,71.9101491 98,75.5 L85,75.5 Z"
              id="Combined-Shape"
            ></path>
            <path
              d="M24,68.5 C24,66.5670034 22.209139,65 20,65 C17.790861,65 16,66.5670034 16,68.5 L24,68.5 Z"
              id="Oval-Copy-4"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  );
};
